import type { IconName } from "@repo/fika-design-system/icon"
import { For, type ParentProps } from "solid-js"
import { Icon } from "@/designSystem/components/icon"
import {
  contentClass,
  iconClass,
  itemClass,
  linkClass,
  listClass,
  wrapperClass,
} from "./section-navigator.css"

export type SectionNavigatorItem = {
  id: string
  title: string
  iconName: IconName
}

type Props = ParentProps & {
  sections: SectionNavigatorItem[]
}

export function SectionNavigator(props: Props) {
  return (
    <div class={wrapperClass}>
      <ul class={listClass}>
        <For each={props.sections}>
          {section => (
            <li class={itemClass}>
              <a href={`#${section.id}`} class={linkClass}>
                <Icon name={section.iconName} class={iconClass} size="18" />
                {section.title}
              </a>
            </li>
          )}
        </For>
      </ul>
      <div class={contentClass}>{props.children}</div>
    </div>
  )
}
